var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,attrs:{"disabled":_vm.disabled}},[_vm._v("\n  "+_vm._s(_vm.text)),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }